import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Collapse, Paper, TextField } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import { GraphData, SelectedNode } from '../types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    container: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: 300,
      zIndex: 1,
    },
    paper: { padding: theme.spacing(1), background: theme.palette.grey[800] },
    consoleLine: {
      color: theme.palette.common.white,
      width: '100%',
      fontFamily: 'monospace',
      fontWeight: 'normal',
      fontSize: 12,
    },
  })
);

interface Props {
  open: boolean;
  onUpdateNodePositions?: (nodes: SelectedNode[], clear?: boolean) => void;
  allData: GraphData;
  reducedData: GraphData;
}

const evalInContext = (js: string, context: any) =>
  function () {
    // tslint:disable-next-line: no-eval
    return eval(js);
  }.call(context);

const GraphViewerConsole = ({
  open,
  allData: data,
  reducedData,
  onUpdateNodePositions,
}: Props) => {
  const classes = useStyles();
  const [text, setText] = useState<string>('');
  const clearNodePositions = () =>
    onUpdateNodePositions && onUpdateNodePositions([], true);
  const handleSubmit = (e: KeyboardEvent<HTMLFormElement>) => {
    e.preventDefault();
    evalInContext(text, { data, reducedData, clearNodePositions });
  };

  const handleChange = (e: ChangeEvent<any>) => {
    e.stopPropagation();
    setText(e.target.value);
  };

  return (
    <Collapse in={open} className={classes.container}>
      <Paper className={classes.paper}>
        <form onSubmit={handleSubmit}>
          <TextField
            autoFocus
            className={classes.consoleLine}
            value={text}
            InputProps={{ classes: { input: classes.consoleLine } }}
            onChange={handleChange}
          />
        </form>
      </Paper>
    </Collapse>
  );
};

export default GraphViewerConsole;
